import * as React from 'react'

import { i18n } from '@thg-commerce/enterprise-core'
import { mq, spacing, styled } from '@thg-commerce/gravity-theme'
import { Pagination } from '@thg-commerce/gravity-elements'
import { ReviewSort } from '@thg-commerce/enterprise-network/src/generated/graphql'

export type ReviewPaginationProps = {
  reviewsPerPage: number
  reviewsTotal: number
  activePage: number
  onPageChange: (newPageNumber: number) => void
  sortName: ReviewSort
}

export const StyledPagination = styled(Pagination)`
  justify-content: center;
  padding-top: ${spacing(4)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    justify-content: right;
  }
`

export const ReviewPagination = (props: ReviewPaginationProps) => {
  const i18nTextPagination = {
    previous: i18n('general.pagination.previous'),
    next: i18n('general.pagination.next'),
    page: i18n('general.pagination.page'),
    ofTotal: i18n('general.pagination.oftotal'),
    dropdownLabel: i18n('general.pagination.dropdownlabel'),
    currentlyOnText: i18n('general.pagination.currentlyontext'),
    ariaLabel: i18n('general.pagination.arialabel'),
  }

  if (props.reviewsPerPage >= props.reviewsTotal) {
    return null
  }

  return (
    <StyledPagination
      itemsPerPage={props.reviewsPerPage}
      totalItems={props.reviewsTotal}
      activePage={props.activePage}
      onPageChange={(newPageNumber) => {
        props.onPageChange(newPageNumber)
      }}
      i18nText={i18nTextPagination}
      trailingSlash={false}
    />
  )
}
